/**
 * Marqueur de session posé par CallbackPage après une connexion standard (mot
 * de passe). Jamais posé par le callback SSO, ni au rechargement de page, ni au
 * renouvellement silencieux du token. Lu par PlateformeChoiceGate.
 */
export const PLATEFORME_CHOICE_PENDING_KEY = 'plateformeChoicePending';

/**
 * Choix de plateforme déjà fait pour ce compte (`plateformeChoiceDone:<sub>`,
 * valeur = date ISO). Un nouvel onglet repasse par CallbackPage (reconnexion
 * silencieuse par cookie) : sans ce repère, l'écran de choix reviendrait à
 * chaque onglet. Effacé par la déconnexion (localStorage.clear()).
 */
const CHOICE_DONE_KEY_PREFIX = 'plateformeChoiceDone:';
const CHOICE_VALIDITY_MS = 12 * 60 * 60 * 1000;

/** Vrai si le choix a été fait pour ce compte il y a moins de 12 heures. */
export const isChoiceStillValid = (sub?: string | null): boolean => {
  if (!sub) return false;
  try {
    const value = localStorage.getItem(CHOICE_DONE_KEY_PREFIX + sub);
    if (!value) return false;
    const doneAt = Date.parse(value);
    return !Number.isNaN(doneAt) && Date.now() - doneAt < CHOICE_VALIDITY_MS;
  } catch {
    return false;
  }
};

/** Enregistre que le choix de plateforme est fait pour ce compte. */
export const markChoiceDone = (sub?: string | null): void => {
  if (!sub) return;
  try {
    localStorage.setItem(CHOICE_DONE_KEY_PREFIX + sub, new Date().toISOString());
  } catch {
    /* stockage indisponible : l'écran de choix reviendra, sans autre effet */
  }
};
